import React, { useCallback } from 'react';
import classNames from 'classnames/bind';
import { useDispatch, useSelector } from 'react-redux';

import {
  setOptions,
  getOptions,
} from '~/modules/chat';

import styles from './index.scss';

const cx = classNames.bind(styles);

const OutlineCropLandscape = () => <svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor" fill="currentColor" height="1em" viewBox="0 -960 960 960" width="1em"><path d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Zm0-60h680v-520H140v520Zm0 0v-520 520Z" /></svg>;
const OutlineRectangle = () => <svg xmlns="http://www.w3.org/2000/svg" stroke="currentColor" fill="currentColor" height="1em" viewBox="0 -960 960 960" width="1em"><path d="M180-280q-24 0-42-18t-18-42v-280q0-24 18-42t42-18h600q24 0 42 18t18 42v280q0 24-18 42t-42 18H180Zm0-60h600v-280H180v280Zm0 0v-280 280Z" /></svg>;

interface TheaterModeProps {
  streamshots: boolean;
}

const TheaterMode:React.FC<TheaterModeProps> = ({ streamshots }) => {
  const dispatch = useDispatch();
  const { viewLayout } = useSelector(getOptions);

  const toggleOption = useCallback(() => {
    if (viewLayout !== 'Theater') {
      dispatch(setOptions({ viewLayout: 'Theater' }));
    } else {
      dispatch(setOptions({ viewLayout: 'Auto' }));
    }
  }, [dispatch, viewLayout]);

  return (
    <>
      <button
        className={`op-navigators op-button ${cx('TheaterMode', { 'TheaterMode--Streamshots': streamshots })}`}
        type="button"
        title={`${viewLayout !== 'Theater' ? 'Theater mode' : 'Default View'}`}
        onClick={toggleOption}
      >
        <i className="op-con" role="img">
          {viewLayout !== 'Theater'
            && <OutlineCropLandscape />
          }
          {viewLayout === 'Theater' && <OutlineRectangle />}
        </i>
      </button>
    </>
  );
};

export default TheaterMode;
